<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <path
        fill="inherit"
        stroke="none"
        d="M8.33 22.33h15.34V19H8.33zM5.74 26q-1 0-1.7-.7a2.3 2.3 0 0 1-.7-1.71V8.41q0-1 .7-1.71.7-.7 1.7-.7h20.52q1 0 1.7.7t.7 1.71v15.18q0 1-.7 1.71-.7.7-1.7.7zm0-2h20.52q.16 0 .28-.13a.4.4 0 0 0 .13-.28V8.41a.4.4 0 0 0-.13-.28.4.4 0 0 0-.28-.13H5.74a.4.4 0 0 0-.28.13.4.4 0 0 0-.13.28v15.18q0 .16.13.28a.4.4 0 0 0 .28.13"
      />
    </svg>
  </span>
</template>
